/* ==========================================================================

 Global Ajax Configuration

 Author:      Dave Taylor (http://davetayls.me)
 Description: Configuration for global ajax handling

 ========================================================================== */
'use strict';

var $ = require('jquery');
var config = require('../js/config');
import {parse} from 'url';

let ALLOWED_HOSTNAMES = [null, window.location.hostname];

export function initGlobalAjaxSettings(requestId) {

  $.ajaxSetup({

    // This allows empty responses from the server to be parsed ok
    // without this jQuery will try and do JSON.parse('') which will fail
    // The server will often just respond with a 200 or a 401 code to indicate
    // the request has succeeded/failed but not include any json in the body
    dataFilter: function(data, type) {
      if (type === 'json' && data === '') {
        data = null;
      }
      return data;
    },

    /**
     * This will add global request headers to all relevant
     * XHR requests
     */
    beforeSend: function(xhr) {
      if (requestId && shouldSetRequestId(this.url)) {
        xhr.setRequestHeader(config.httpHeaders.requestId, requestId);
      }
    }

  });

}

function shouldSetRequestId(url = '') {
  if (!url) return false;
  let urlParts = parse(url);
  return ALLOWED_HOSTNAMES.indexOf(urlParts.hostname) > -1;
}






// WEBPACK FOOTER //
// ./assets/utilities/ajaxSetup.js